/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Growthnav1Inputs */

const en_growthnav1 = /** @type {(inputs: Growthnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Growth map`)
};

const de_growthnav1 = /** @type {(inputs: Growthnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachstumskarte`)
};

/**
* | output |
* | --- |
* | "Growth map" |
*
* @param {Growthnav1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const growthnav1 = /** @type {((inputs?: Growthnav1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Growthnav1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_growthnav1(inputs)
	return de_growthnav1(inputs)
});
export { growthnav1 as "growthNav" }